import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
	name : 'tolocalestring'
})
export class ToLocaleStringPipe implements PipeTransform {

	transform(string: string): string
	{
		if (string == '') return '';
		return _.toNumber(string).toLocaleString();
	}

}
